import React from 'react';

import APPCONFIG from "constants/Config";
import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/dashboard',
		icon: 'dashboard',
	},
	{
		name: 'Locations',
		url: '/locations',
		icon: 'building',
	}
];

export default class Location extends Framework.Components.View {

	constructor(props) {
		super(props);
	}

	render() {
		let breadcrumbs = breadcrumbsStatic.slice().concat([
			{
				name: this.state.name,
				url: `/locations/${this.props.id}`,
				icon: 'edit',
			}
		]);

		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}/>

				<Framework.Errors.General isDev={APPCONFIG.settings.isDev()}>
					<Objects.Location
						id={this.props.match.params.id}
						locations={this.props.locations}
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						afterSave={this.refreshPage}
						reloadSelf={this.state.refresh}
						updateName={this.updateName}
						noDelete={false}
						baseUrl={this.props.baseUrl}
						ffl_boss_linked={this.props.ffl_boss_linked}
					/>
				</Framework.Errors.General>
			</div>
		)
	}
}
